<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item active" aria-current="page">
      <span>Preping Tool</span>
    </li>
  </ol>
</nav>

<div class="card border-0 shadow mb-3 fade-in-zoom">
  <div class="card-body">
    <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
      <div class="row g-3 mb-3">
        <div class="col-4">
          <label for="email" class="form-label">Email</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-envelope"></i></span>
            <input id="email" class="form-control" formControlName="email">
          </div>
        </div>

        <div class="col-4">
          <label class="form-label fw-bold small">Language</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-translate"></i></span>
            <app-dropdown-select formControlName="lang">
              @for (lang of languages; track lang) {
                <app-dropdown-select-option [value]="lang.isoCode">
                  <img [ngSrc]="langService.getLanguageFlag(lang)" [alt]="lang.name" class="country-flag"
                       width="24" height="24">
                  {{ lang.name }}
                </app-dropdown-select-option>
              }
            </app-dropdown-select>
          </div>
        </div>

        <div class="col-4">
          <label for="productPriority" class="form-label">Product</label>
          <app-product-priority-selector id="productPriority" formControlName="product" [selectMode]="true"
                                         [lang]="null"></app-product-priority-selector>
        </div>
      </div>

      <div class="col-auto text-end">
        <button type="submit" class="btn btn-primary fw-bold" [disabled]="!form.valid">
          <span>Preping</span>
        </button>
      </div>
    </form>

    @if (leadUpPreping) {
      <div
        class="bg-tertiary p-2 border-start border-warning border-5 d-flex justify-content-between align-items-center mb-3 mt-5">
        <h2 class="fw-bold fs-6 mb-0">LeadUp preping result</h2>
      </div>

      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
          <tr>
            <th>Brand</th>
            <th>Result</th>
          </tr>
          </thead>
          <tbody>
            @for (item of leadUpPreping | keyvalue; track item.key) {
              <tr>
                <td>{{ item.key }}</td>
                <td>
                  <span [ngClass]="getPrepingClass(item.value)">{{ item.value }}</span>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }

    @if (productPreping) {
      <div
        class="bg-tertiary p-2 border-start border-warning border-5 d-flex justify-content-between align-items-center mb-3 mt-5">
        <h2 class="fw-bold fs-6 mb-0">Oktopus preping result</h2>
      </div>

      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
          <tr>
            <th>Priority</th>
            <th>Brand</th>
            <th>Identifier</th>
            <th>P2</th>
            <th>Xsell</th>
          </tr>
          </thead>
          <tbody>
            @for (product of productPreping['products']; track product.id) {
              <tr>
                <td>{{ ($index + 1) }}</td>
                <td>{{ product.name }}</td>
                <td>{{ product.identifier }}</td>
                <td>
                  @if (product.coreg) {
                    <span class="text-success">
                      <i class="bi bi-check-circle-fill"></i>
                    </span>
                  } @else {
                    <span class="text-danger">
                      <i class="bi bi-slash-circle-fill"></i>
                    </span>
                  }
                </td>
                <td>
                  @if (product.cross) {
                    <span class="text-success">
                      <i class="bi bi-check-circle-fill"></i>
                    </span>
                  } @else {
                    <span class="text-danger">
                      <i class="bi bi-slash-circle-fill"></i>
                    </span>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
</div>
